import request from '@/utils/request'

//获取验证码
export const getLoginInfo = (data) => {
  return request({
    url: '/login/getLoginInfo',
    method: 'post',
    data,
    encrypt: true,
  })
}

//获取验证码
export const getSignature = (data) => {
  return request({
    url: '/mini/wxGetSignature',
    method: 'post',
    data,
    encrypt: true,
  })
}

//查询当前登录账号是否激活192邮箱
export const queryUserIfOrderMailbox = (data) => {
  return request({
    url: '/invoice/queryUserIfOrderMailbox',
    method: 'post',
    data,
    encrypt: true,
  })
}
